import { HeaderLink } from '@/hooks/useHeader/types';

export const MAGAZINE_HEADER_NAV_ITEMS: HeaderLink[] = [
  {
    isInternalUrl: true,
    title: '#deine Stadt',
    url: '/magazin/deine-stadt',
  },
  {
    isInternalUrl: true,
    title: '#unsere Welt',
    url: '/magazin/unsere-welt',
  },
  {
    isInternalUrl: true,
    title: '#mein Leben',
    url: '/magazin/mein-leben',
  },
];
